import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const SIGNAL_RECOMMENDER_BASE_KEY = "signalRecommender";
const FILES_KEY = "files";

const ALL_KEY = [SIGNAL_RECOMMENDER_BASE_KEY] as const;

export const signalRecommenderQueryKeys = {
    all() {
        return ALL_KEY;
    },

    files() {
        return [...ALL_KEY, FILES_KEY] as const;
    },
} satisfies QueryKeyFactory;
